import { ChipInput, CustomSelect, TextInput } from "../../components";
import { ToggleButtons } from "@/utils/ui/ToogleButtons/ToggleButtons";

import React from "react";
import { useFormik } from "formik";

const CreateThread = () => {
  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      subscribers: [],
      notifications: "0",
      logoUrl: "",
      logoBase64: "",
      parentBusiness: "",
    },
    onSubmit: (values) => {
      console.log(values);
    },
  });

  return (
    <div className="container-sm">
      <div className="d-flex justify-content-between p-3 py-2 align-items-center bg-white shadow-sm mb-3">
        <div className="d-flex justify-content-center align-items-center gap-2">
          <i className="bi bi-arrow-left pointer"></i>
          <span>Create Thread</span>
        </div>
      </div>
      <div className="py-2">
        <TextInput
          name="name"
          label="Name"
          value={formik.values.name}
          onChange={(e) => {
            formik.handleChange(e);
            if (e.target.value.length > 100) {
              formik.setFieldError("name", "name is too long");
            }
          }}
          characterLimit={100}
          onBlur={() => {}}
          error={formik.errors.name}
          touched={formik.touched.name}
        />
        <TextInput
          name="description"
          label="Description"
          value={formik.values.description}
          onChange={(e) => {
            formik.handleChange(e);
            if (e.target.value.length > 100) {
              formik.setFieldError("description", "description is too long");
            }
          }}
          characterLimit={100}
          onBlur={() => {}}
          error={formik.errors.description}
          touched={formik.touched.description}
        />

        {/* <ThumbUpload
          name="thumbnail"
          onBlur={() => {}}
          label="Thumbnail"
          value={formik.values.logoUrl}
          handleChange={(thumbUrl, thumbBase64) => {
            formik.setFieldValue('logoUrl', thumbUrl);
            formik.setFieldValue('logoBase64', thumbBase64);
          }}
        /> */}
        <CustomSelect
          className="mt-3"
          label="parentBusiness"
          value={formik.values.parentBusiness}
          options={[]}
          handleChange={(newValue: any) => {
            formik.setFieldValue("parentBusiness", newValue.value);
          }}
          placeholder={"Select Organisation"}
          showRequired={true}
          touched={formik.touched.parentBusiness}
          error={formik.errors.parentBusiness}
        />
        <ChipInput
          label="Subscribers"
          value={formik.values.subscribers}
          handleChipChange={(chip, action) => {
            if (action === "add") {
              formik.setFieldValue("subscribers", [
                ...new Set([...formik.values.subscribers, chip]),
              ]);
            } else if (action === "remove") {
              formik.setFieldValue(
                "subscribers",
                formik.values.subscribers.filter((t) => t !== chip)
              );
            } else if (action === "clear") {
              formik.setFieldValue("subscribers", []);
            }
          }}
        />
        <ToggleButtons
          name="notifications"
          label="Notifications"
          options={[
            { label: "ON", value: "1" },
            { label: "OFF", value: "0" },
          ]}
          selectedValue={formik.values.notifications}
          handleChange={(newValue: any) => {
            formik.setFieldValue("notifications", Number(newValue));
          }}
        />
      </div>
      <div className="border-top p-3 mt-5 d-flex justify-content-end">
        <div className="btn btn-primary">CREATE</div>
      </div>
    </div>
  );
};

export default CreateThread;
